import { ApiError } from "../../../../lib/api.js";

/**
 * A human-readable reason for a failed draft delete. `api()` throws an
 * `ApiError` whose `.message` is the dashboard proxy's typed reason — e.g.
 * "Marketing app returned 404" (the service is reachable but lacks the delete
 * route — an older build) or "Marketing app unreachable". Surfacing it turns
 * the old silent failure into something the operator can act on. Extracted from
 * `PendingApprovalTable.tsx` so it unit-tests directly.
 */
export function deleteErrorDetail(err: unknown): string {
  if (err instanceof ApiError) return err.message;
  return err instanceof Error ? err.message : "Please try again.";
}
